import { render, staticRenderFns } from "./AssignTreatmentModal.vue?vue&type=template&id=69272617&scoped=true"
import script from "./AssignTreatmentModal.vue?vue&type=script&lang=ts"
export * from "./AssignTreatmentModal.vue?vue&type=script&lang=ts"
import style0 from "./AssignTreatmentModal.vue?vue&type=style&index=0&id=69272617&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69272617",
  null
  
)

export default component.exports